import React, { Component, Fragment } from 'react';
import { BeatLoader } from 'react-spinners';
import moment from 'moment';
import PropTypes from "prop-types";
import $ from 'jquery'
import { Tab, TabList, Tabs } from 'react-tabs';
import ReactTable from 'react-table';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import Datetime from 'react-datetime';
import NotificationSystem from 'react-notification-system';
import { getTransactionOptions } from './../../../Misc/MenuOptions/menuOptionsActions';
import MenuOptions from './../../../Misc/MenuOptions/menuOptions';
import { _addNotification, _addNotificationError, getCEPBulkTransactionsType, getSchoolGrades, groupBy } from '../../../../server/util';
import { getTeachers, getTransactions } from './bulkTransactionService.js';
import '../../../../../src/assets/css/react-table.css';
import 'react-tabs/style/react-tabs.css';
import CustomSubmit from '../../../Misc/customSubmit';
import { BULK_TRANS_TYPE, date_format } from '../../../../server/constants';
import ItemListComponent from './itemListComponent';
import MealCountComponent from './mealCountComponent';
import MealCountComponentV2 from './mealCountComponentV2.js';
const CheckboxTable = checkboxHOC(ReactTable);
const excludeGrades = ['staff', 'teachers'];
const today = moment();
const disableFutureDt = current => {
    return current.isBefore(today)
};
let gradeList = [];
let allGradeList = [];
class BulkTransactions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            mealType: (getTransactionOptions()[0] || ''),
            selectedDate: moment(),
        }
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    setLoading = (state) => {
        this.setState({ loading: state });
    }



    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    render() {
        const { loading, selectedDate, mealType, teachers } = this.state;
        gradeList = getSchoolGrades(0, false);
        allGradeList = getSchoolGrades(0, true);
        return (
            <section className=" full-width clearfix">
                <NotificationSystem ref="notificationSystem" />
                <div className="container">
                    <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={loading}
                        />
                    </div>
                    <div className="sectionTitle">
                        <div className="row">
                            <div className="col-md-2">
                                <h2><span>Bulk Transactions</span></h2>
                            </div>
                        </div>
                        <div className='row'>

                            <div className="uploadFileInfo col-md-4 createmenu-month-group">
                                <div className='col-md-2' style={{ width: '120px' }}>
                                    <label style={{ marginTop: '10px', fontSize: '14px' }}>Served Date:</label></div>
                                <div className="input-group col-md-8 col-sm-12 col-xs-12" style={{ margin: '0px' }}>
                                    <Datetime ref='trCalendar' dateFormat={date_format()} timeFormat={false} isValidDate={disableFutureDt}
                                        closeOnSelect={true} value={moment(this.state.selectedDate, 'YYYY-MM-DD')}
                                        onChange={(e) => {
                                            this.setState({ selectedDate: moment(e) }, () => {
                                                if (getCEPBulkTransactionsType() == BULK_TRANS_TYPE.MEALCOUNT) {
                                                    this.refs.mealCountCtrl.getDate_MenuTypeChangeData();
                                                } else {
                                                    this.refs.itemListCtrl.getDate_MenuTypeChangeData();
                                                }
                                            });
                                            this.refs.trCalendar.closeCalendar();
                                        }} renderInput={this.renderInput} />
                                </div>
                            </div>

                            <div className="col-md-8 text-right" style={{ marginBottom: '5px' }}>
                                <div style={{ display: 'inline-block' }}>
                                    <MenuOptions menuOptionsList={getTransactionOptions()} onOptionSelect={(type) => {
                                        this.setState({ mealType: type }, () => {
                                            if (getCEPBulkTransactionsType() == BULK_TRANS_TYPE.MEALCOUNT) {
                                                this.refs.mealCountCtrl.getDate_MenuTypeChangeData();
                                            } else {
                                                this.refs.itemListCtrl.getDate_MenuTypeChangeData()
                                            }
                                        })
                                    }} selectedOption={(this.state.mealType)} />
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className="tab-content">
                                    <div className="panel panel-primary">
                                        <div className="panel-body">
                                            {
                                                getCEPBulkTransactionsType() == BULK_TRANS_TYPE.MEALCOUNT ? <Fragment>
                                                    <MealCountComponentV2 ref='mealCountCtrl' {...{ selectedDate, mealType, setLoading: this.setLoading, ...this }} />
                                                    {/* <MealCountComponent ref='mealCountCtrl' {...{gradeList:((allGradeList||[]).filter(grade=> !excludeGrades.includes(grade.value))), selectedDate, mealType, setLoading:this.setLoading, ...this }} /> */}

                                                </Fragment>
                                                    : <ItemListComponent ref='itemListCtrl' {...{ gradeList: ((gradeList || []).filter(grade => !excludeGrades.includes(grade.value))), selectedDate, mealType, setLoading: this.setLoading, ...this }} />
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        );
    }
}
BulkTransactions.contextTypes = {
    router: PropTypes.object.isRequired
}

export default BulkTransactions;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Transactions/bulkTransactions/index.js